/**
 * Step2 Component: tipo_riscaldamento
 */

 import React, { Component } from 'react';

 import appStore from '../../../redux/store/appStore';
 import { updateGui, updateConfiguration } from '../../../redux/actions/actions';
 
 import Step from './Step';
 import StepRadioOptions from './StepRadioOptions';
 
 import { stepEditingDataId2CoreId, nextPermissionDeniedGuiFeedback } from '../../../helpers/wizard-helper';
 
 import { getItem } from '../../../helpers/object-helper';
 
 import './Step2.css';
 
 class Step2 extends Component {
 
     constructor(props) {
         super(props);
         this.stepNum = props.stepNum;
         this.stepConf = props.stepConf;
         this.editingDataId = this.stepConf.dataId;
         this.stepText = this.stepConf.text;
         this.stepInfo = this.stepConf.info;
         this.options = this.stepConf.options;
         this.isValidated = this.isValidated.bind(this);
         this.onOptionChange = this.onOptionChange.bind(this);
         this.state = this.getInitialState(this.options);
     }
 
     componentDidMount() {
         
         appStore.dispatch(updateGui({
             currentEditingData: this.editingDataId
         }));
 
         this.updateState(this.getSelectedOptionValueFromStore());
 
     }
 
     /**
      * Returns the inital state
      * @param {Object[]} options
      *  [n]
      *      .label {String}
      *      .value {String}
      * @returns {Object}
      *  .selectedOptionId {String}
      *  .nuova {Boolean}
      *  .sostituzione {Boolean}
      */
     getInitialState(options) {
         const state = {
             selectedOptionId: null
         };
         this.options.forEach(option => {
             state[option.value] = false;
         });
         return state;
     }
 
     /**
      * Updates component state selecting selectedOptionId
      * @param {String} selectedOptionId
      */
     updateState(selectedOptionId) {
 
         if (selectedOptionId === null) {
             return;
         }
 
         const newState = {
             ...this.getInitialState(this.options),
             [selectedOptionId]: true,
             selectedOptionId
         }
 
         this.setState(() => newState);
 
     }
 
     /**
      * Step validation
      * @param {Boolean} showWarnMessage optional
      *  = undefined when call stack begins with btn next click, going through Stepzilla internals
      *      -> reacting to btn next click must show the warn message
      *  = Boolean (false) when call stack starts from Step.nextPermissionListener()
      *      -> reacting to redux store properties changes must not show the warn message
      */
     isValidated(showWarnMessage) {
 
         const data = getItem(this.editingDataId, appStore.getState());
         const valid = (data !== null);
 
         if (!valid && showWarnMessage === undefined) {
             nextPermissionDeniedGuiFeedback(this, this.stepNum, true);
         }
 
         return valid;
 
     }
 
     /**
      * Returns from the store the value of the piece of data related to this step ('configuration.tipo_riscaldamento')
      * @return {HTMLElement|null}
      */
     getSelectedOptionValueFromStore() {
         return getItem(this.editingDataId, appStore.getState());
     };
 
     /**
      * On change event listener for radio option
      */
     onOptionChange(evt) {
 
         const optionValue = evt.target.value;
         this.updateState(optionValue);
 
         appStore.dispatch(updateConfiguration({
            [stepEditingDataId2CoreId(this.editingDataId)]: optionValue
         }));
 
         this.isValidated();
 
     }
 
     body() {
         return (
             <div className={`slc-${ stepEditingDataId2CoreId(this.editingDataId) }`}>
                 <StepRadioOptions
                     stepText={ this.stepText }
                     stepInfo={ this.stepInfo }
                     name={ this.editingDataId.split('.')[1] }
                     options={ this.options }
                     interactionData={ this.state }
                     onOptionChange={ this.onOptionChange } />
             </div>
         );
     }
 
     render() {
         return <Step 
                 stepComponent={ this }
                 stepNum={ this.stepNum }
                 stepBody={ this.body() } />;
     }
     
 }
 
 export default Step2;